import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgCartFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m5.08 4 .77 9.25A3 3 0 0 0 8.84 16h8.598a3 3 0 0 0 2.91-2.272l1.622-6.485A1 1 0 0 0 21 6H7.253l-.256-3.083A1 1 0 0 0 6 2H3a1 1 0 0 0 0 2h2.08ZM8 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm10-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z", fill: color }));
};
export default factorySvgIcon(SvgCartFilled);
//# sourceMappingURL=SvgCartFilled.js.map